import { useLocation } from "react-router-dom";

export const useURLParam = <T = string>(param: string): T | null => {
    const { search } = useLocation();

    return JSON.parse(new URLSearchParams(search).get(param) ?? "null");
};
